import React, {
  FunctionComponent,
  MouseEventHandler,
  useEffect,
  useMemo,
  useState,
} from "react";
// @ts-ignore
import YouTube from "react-youtube";
import LoadingIndicator from "../../../onboarding/LoadingIndicator";
import useUserRole from "../../../../../utils/hooks/useUserRole";
import { UserAssignmentRole } from "../../../../../store/auth/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";

type OwnProps = {
  onClick: MouseEventHandler<any>;
  messageParts?: Array<string>
  fromRecommendation?: boolean;
};

type Props = OwnProps;

const IntroPanel: FunctionComponent<Props> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const showDiagnosedStudentCheck = useSelector<
  ApplicationState,
  boolean
>((s) => s.dataFilter.showDiagnosedStudentFilter);

  useEffect(() => {
    setLoading(true);
  }, []);

  const { role, isCoach, isTeacher } = useUserRole();

  // const info = useMemo(() => {
  //   switch (role) {
  //     case UserAssignmentRole.COACH:
  //       return `Get started by uploading your data. For guidance, watch the tutorial under
  //        <strong>Explore & Learn › Video Tutorials</strong> section.`;
  //     // case UserAssignmentRole.TEACHER:
  //     //   return `Get started by uploading data. For help uploading data, 
  //     //   access the video tutorial in the Explore and Learn section.`;
  //     case UserAssignmentRole.SUPERVISOR:
  //       return "Wait until teachers and coaches set up groups.";
  //     default:
  //       return null;
  //   }
  // }, [role]);

  return (
    <div className="dataContainer text-center" data-cy="groups-container-intro">
      {props.fromRecommendation && showDiagnosedStudentCheck
      ?
        <div>
          <h2 className="font-weight-bold mb-2">
            Welcome! You don’t have any students with diagnostics assigned in this data period.
          </h2>
          <p className="mb-3">Get started by adding <strong>Diagnostic Skill Information</strong> for this data period in the <strong>My Data</strong> menu.</p>
        </div> 
      :
        <div>
          <h2 className="font-weight-bold mb-2">
            Welcome! You don’t have any recommended groups {props.messageParts?.length ? ' for the applied filter': 'yet'}. 
          </h2>
          <p className="mb-3">Get started by uploading your data. For guidance, watch the tutorial under <strong>Video Tutorials</strong> menu.</p>
          {/* <p
            className="mb-3"
            dangerouslySetInnerHTML={info ? { __html: info } : undefined}
          /> */}
          {/* {loading && <LoadingIndicator />}
          <div style={loading ? { display: "none", height: 0 } : undefined}>
            <YouTube
              onReady={() => setLoading(false)}
              videoId="0VX1gv8itB0"
              opts={{ width: "50%" }}
            />
          </div> */}
        </div>
      }

      {!isTeacher && (
        <button
          className="blueBtnLg mt-3"
          onClick={props.onClick}
          data-cy="start"
        >
          Get Started
        </button>
      )}
    </div>
  );
};

export default IntroPanel;
